// extracted by mini-css-extract-plugin
export default {"formGroup":"confirm_formGroup__jD9Ft","inputGroup":"confirm_inputGroup__cXsm0","error":"confirm_error__axORf","uploadButton":"confirm_uploadButton__iiwfs"};